export default {
    login_url: '/login',
    signup_url: '/user/register',
    forgot_url: '/user/forgotPassword',
    rest_password_url: '/user/restPassword',
    test_url: '/questionnaire/info',
    test_submit_url: '/questionnaire/submit',
    test_result_url: '/questionnaire/history',
    test_history_url: '/questionnaire/historyList',
    verify_image_url:'/verifyImage',
    do_verify_url:'/verify',
    verify_image_url2:'/verifyImage2',
    do_verify_url2:'/verify2',
    do_manager_validate_url:'/manager/validate',
    do_manager_all_user_url:'/manager/allUser',
    do_manager_history_url:'/manager/history',

    // result code
    result_success: 200,//请求成功
    result_fail: 300,//请求错误
    result_out_date: 301,//请求超时
    result_verified: 302,//需要登陆验证
    result_manager:303,//需要管理员权限

    //message
    out_time_msg: 'Login Timeout',  //登录超时
    request_error_msg: 'Request Error', //请求出错


    //other
    test_page_length: 5,    //测试页每页多少条数据
    test_result_colors: ['#50b845','#fde800','#ed1b24'],    //测试结果，条形图渐变颜色区间
    message_time: 1000,    // 全局弹窗消息持续时间
}
